import type {
  DynamicArtworkField,
  DynamicFieldErrors,
  DynamicFieldValue,
  DynamicFieldValues
} from './dynamicProofingFormTypes'
import type { ReactNode } from 'react'
import { Col, Row } from 'reactstrap'
import * as Inputs from './form_fields'
import ArtworkAddressBookSelect from './form_fields/ArtworkAddressBookSelect'

type DynamicArtworkFieldListProps = {
  fields: DynamicArtworkField[]
  values: DynamicFieldValues
  fieldErrors: DynamicFieldErrors
  onChange: (value: DynamicFieldValue, field: DynamicArtworkField) => void
  onShiftBulletValue: (previousFieldName: string, fieldName: string, value: DynamicFieldValue) => void
}

type InputRenderer = (
  field: DynamicArtworkField,
  value: DynamicFieldValue,
  handleChange: (value: DynamicFieldValue, field: DynamicArtworkField) => void,
  values: DynamicFieldValues
) => ReactNode

const inputMap: Record<string, InputRenderer> = {
  date: Inputs.ArtworkDateInput,
  text: Inputs.ArtworkTextInput,
  address_1_line_1: Inputs.ArtworkAddressLine1Fields,
  phone: Inputs.ArtworkPhoneInput,
  select: Inputs.ArtworkSelectInput,
  number: Inputs.ArtworkNumberInput
}

const DynamicArtworkFieldList = ({
  fields,
  values,
  fieldErrors,
  onChange,
  onShiftBulletValue
}: DynamicArtworkFieldListProps) => (
  <Row>
    {fields.map(field => {
      if (!field.is_active) return null

      const value = values[field.name] || ''
      const InputComponent = inputMap[field.html_input_type]
      if (!InputComponent) return null

      if (field.is_bullet && field.name !== 'bullet_01') {
        const previousBulletNumber = parseInt(field.name.split('_')[1]) - 1
        const previousFieldName = `bullet_0${previousBulletNumber}`
        const previousBulletValue = values[previousFieldName]

        if (!previousBulletValue) {
          if (value) {
            onShiftBulletValue(previousFieldName, field.name, value)
          }
          return null
        }
      }

      return (
        <Col key={field.id} sm={field.form_field_width || 12}>
          {field.is_address_book ? (
            <ArtworkAddressBookSelect
              artworkField={field as never}
              value={value as never}
              handleChange={onChange as never}
            />
          ) : (
            InputComponent(field, value, onChange, values)
          )}
          {field.is_url === true ? (
            <div>
              <p className="small-help">&nbsp;Please enter a valid URL, example: https://www.google.com</p>
              <p className="red-text">
                {typeof value === 'string' && value.length > 0 && fieldErrors[field.name]?.message}
              </p>
            </div>
          ) : (
            <br />
          )}
        </Col>
      )
    })}
  </Row>
)

export default DynamicArtworkFieldList
